<div class="alt-row-between">
  <p class="alt-inter-bold alt-size-20 ">{{"ORGANIZATION.edit-group" | translate }}</p>
  <mat-icon class="poiter" svgIcon="crossMenu" (click)="closeModal()"></mat-icon>
</div>

<p class="create-main-text  alt-inter-medium alt-size-16 ">{{"ORGANIZATION.edit-instrucction" | translate}}</p>

<div class="made-group-container-form">
  <form [formGroup]="groupForm" class="made-group-form alt-flex-column input-format" (ngSubmit)="sendData(groupForm)">
    <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-field margin-field1"
      appearance="outline">
      <mat-label class="alt-inter-medium alt-size-16">{{"USERS.group-name" | translate }}</mat-label>
      <input matInput formControlName="groupName">
    </mat-form-field>

    <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-field margin-field1"
      appearance="outline">
      <mat-label class="alt-inter-medium alt-size-16">{{"FACILITATOR.facilitator-on-charge" | translate }}</mat-label>
      <mat-select matInput formControlName="facilitatorName">
        <mat-option *ngFor="let facilitator of alliedFacilitators" [value]="facilitator._id">
          <p>{{facilitator.names}} {{facilitator.surnames}} </p>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="date-fields alt-row-align-center">
      <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-date-field" appearance="outline">
        <mat-label class="alt-inter-medium alt-size-16">{{"USERS.date-ini" | translate }}</mat-label>

        <input readonly matInput [min]="minDate" formControlName="startDate" [matDatepicker]="dp1" (click)="dp1.open()">

        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="hideRequiredControl.value" class="form-date-field margin-left"
        appearance="outline">
        <mat-label class="alt-inter-medium alt-size-16">{{"USERS.date-end" | translate }}</mat-label>

        <input readonly formControlName="endDate" matInput [min]="minDate" [matDatepicker]="dp2" (click)="dp2.open()">

        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>
    </div>
    <button class="create-button pointer" [disabled]="groupForm.invalid" [class.btn-disabled]="groupForm.invalid">
      {{"FACILITATOR.save-changes" | translate | uppercase }}
    </button>
  </form>
</div>
